import { RecordItem, ParamsType } from 'rcx_adapter';

import { ServiceNowAdapterEvent } from '../enums';
import type { SnClickToDialItem, RingCXCall, RingCXChat, LocalTask } from '../interfaces';
import EventEmitter, { noop, TEventCB } from '../utils/eventEmitter';

export interface ServiceNowAdapterOptions {
    config: AdapterConfig;
    global?: Window & typeof globalThis;
    immediate?: boolean;
    storage?: Storage;
    openFrameInitCallback?: () => void;
}

export type AdapterConfig = {
    frameSrc?: string;
    id?: string;
    version: string;
};

export interface InitTransportData {
    brandName: string;
    currentLocale: string;
}

export interface Configuration {
    clientId: string;
    clientSecret: string;
    domain: string;
}

export class ServiceNowAdapterEventEmitter extends EventEmitter<ServiceNowAdapterEvent> {
    on(event: ServiceNowAdapterEvent.CLICK_TO_DIAL, listener: (data: SnClickToDialItem[]) => void): noop;
    on(event: ServiceNowAdapterEvent.RINGCX_FRAME_LOAD, listener: TEventCB): noop;
    on(event: ServiceNowAdapterEvent.HIDE_RCX_IFRAME, listener: noop): noop;
    on(event: ServiceNowAdapterEvent.UPDATE_IS_LOADING, listener: TEventCB): noop;
    on(event: ServiceNowAdapterEvent.UPDATE_IS_ERROR, listener: TEventCB): noop;
    on(event: ServiceNowAdapterEvent.UPDATE_SECOND_IFRAME_STATUS, listener: TEventCB): noop;
    on(event: ServiceNowAdapterEvent.RESET_SECOND_IFRAME, listener: TEventCB): noop;
    on(...args: any) {
        return super.on.apply(this, args);
    }
}

export interface ServiceNowRecordItem extends RecordItem {
    sys_id?: string;
    sys_class_name?: string;
}

export interface UpdateStorageLogOptions {
    id: string;
    rawData: any;
    paramsType: ParamsType;
}

export type SNSaveLogOptions = {
    paramsType: ParamsType;
    storageLogData: LocalTask;
    callLogSysId?: string;
};

export interface InitStorageLogOptions {
    id: string;
    paramsType: ParamsType;
    params: RingCXCall | RingCXChat;
}
